

import { useAuthContext } from './useAuthContext'

export const useLogout = (AuthContext, resetContextFn=() => {}) => {
  const { dispatch } = useAuthContext(AuthContext)


  const logout = () => {
    // remove user from storage
    localStorage.removeItem('user')
    // dispatch logout action
    dispatch({ type: 'LOGOUT' })
    resetContextFn()
  }

  return { logout }
}